exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-65349f9e] .el-tabs{height:100%}[data-v-65349f9e] .el-tabs .el-tabs__content{height:calc(100% - 55px)}[data-v-65349f9e] .el-tabs .el-tabs__content .el-tab-pane{height:100%;overflow-y:auto}", ""]);

// exports
